global.HOST_API_MOCK = 'https://rap.qidian.com/'

// 根据客户端初始化赋值
global.PLATFORMID = 1
global.API_HOST = ''
global.WEB_HOST_HTTP = ''
global.APP_HOST = ''
global.APP_NAME = ''
global.COIN_NAME = ''
global.NEW_APP_HOST = ''
global.LY_API_HOST = ''

// mta 根据客户端初始化赋值
global.MTA_SID = ''
global.MTA_CID = ''
global.MTA_HID = ''

// 统计action定义
global.STATISTIC_ACTION_ACCESS = 'access' // 进入页面
global.STATISTIC_ACTION_ACT = 'act' // 活动
global.STATISTIC_ACTION_DOWNLOAD = 'download' // app下载
global.STATISTIC_ACTION_GIFT = 'gift' // 礼包按钮
global.STATISTIC_ACTION_LOAD = 'load' // 服务端收到客户端的请求
global.STATISTIC_ACTION_MOREGIFT = 'moreGift' // 更多礼物
global.STATISTIC_ACTION_OPENAPP = 'openApp' // 打开app游戏
global.STATISTIC_ACTION_OPENH5 = 'openH5' // 打开H5游戏
global.STATISTIC_ACTION_OPENINDEX = 'openIndex' // 游戏详情页打开关联游戏
global.STATISTIC_ACTION_OPENDETAIL = 'openDetail' // 游戏主页打开游戏详情页
global.STATISTIC_ACTION_DOWNLOADCOMPLETE = 'downloadcomplete' // 下载完成
global.STATISTIC_ACTION_SHARE = 'share' // 分享
global.STATISTIC_ACTION_MESSAGE = 'message' // 消息
global.STATISTIC_ACTION_TEMP = 'temp' // 临时统计
// 详情页
global.STATISTIC_ACTION_ACTMORE = 'actMore' // 更多活动
global.STATISTIC_ACTION_ACTAD = 'actAD' // 点击详情页活动
global.STATISTIC_ACTION_DETAIL_IMG_CLICK = 'detailImgClick' // 详情页游戏介绍图点击
global.STATISTIC_ACTION_DETAIL_IMG_CLOSE = 'detailImgClose' // 详情页游戏介绍图关闭
global.STATISTIC_ACTION_DETAIL_IMG_SWIPER = 'detailImgSwiper' // 详情页游戏介绍图滑动
global.STATISTIC_ACTION_BACK = 'back' // 退出页面
global.STATISTIC_ACTION_DETAIL_GAME_MORE = 'detailGameMore' // 详情页更多游戏
// 底部栏
global.STATISTIC_ACTION_BOTTOM = 'bottom' // 底部菜单栏
global.STATISTIC_ACTION_BOTTOM_ACT_RED = 'bottomActRed' // 底部菜单栏活动红点
global.STATISTIC_ACTION_BOTTOM_MINE_RED = 'bottomMineRed' // 底部菜单栏我的红点
// 分类
global.STATISTIC_ACTION_CATEGORY_TOP_HREF = 'categoryTopHref' // 分类顶部导航1-7
global.STATISTIC_ACTION_CATEGORY_BANNER_CLICK = 'categoryBannerClick' // 分类banner图点击
global.STATISTIC_ACTION_CATEGORY_BANNER_SHOW = 'categoryBannerShow' // 分类banner图点击
global.STATISTIC_ACTION_CATEGORY_CARD = 'categoryCard' // 分类card
// global.STATISTIC_ACTION_CATEGORY_BUTTON = 'categoryButton' // 分类按钮
// 活动专区
global.STATISTIC_ACTION_ACT_PAGE = 'actPage' // 活动专区活动分页 1 活动 2 预约
global.STATISTIC_ACTION_ACT_ACTIVY_CARD = 'actActivyCard' // 活动card
global.STATISTIC_ACTION_ACT_RESERVE_CARD = 'actReserveCard' // 预约card
global.STATISTIC_ACTION_ACT_RESERVE_BUTTON = 'actReserveButton' // 预约按钮
// 排行
global.STATISTIC_ACTION_RANK_CARD = 'rankCard' // 排行card转化
// global.STATISTIC_ACTION_RANK_BUTTON = 'rankButton' // 排行按钮

global.STATISTIC_ACTION_REWARD_ITEM_CLICK = 'rewardItemClick' // 领币页单条点击
global.STATISTIC_ACTION_REWARD_ITEM_CARD_CLICK = 'rewardItemCardClick' // 领币页CARD单条点击
global.STATISTIC_ACTION_REWARD_BANNER_CLICK = 'rewardBannerClick' // 领币页广告点击

global.STATISTIC_ACTION_BALL_OPEN_CLICK = 'ball_open' // 打开悬浮球
global.STATISTIC_ACTION_BALL_GAME_CLICK = 'ball_game_click' // 点击悬浮球游戏标签
global.STATISTIC_ACTION_BALL_GAME_RECENTPLAY_CLICK = 'ball_game_recebtplay_click'  // 悬浮球游戏标签页最近玩
global.STATISTIC_ACTION_BALL_GAME_RECOMMEND_CLICK = 'ball_game_recommend_click'  // 悬浮球游戏推荐二维
global.STATISTIC_ACTION_BALL_COUPON_CLICK = 'ball_coupon_click' // 点击礼包
global.STATISTIC_ACTION_BALL_MSG_CLICK = 'ball_msg_click' // 点击消息
global.STATISTIC_ACTION_BALL_ACT_PAGE = 'ball_act_page' // 活动页面
global.STATISTIC_ACTION_BALL_ACT_CLICK = 'ball_act_click' // 点击活动
global.STATISTIC_ACTION_BALL_ACT_ITEM_CLICK = 'ball_act_item_click' // 点击活动条目
global.STATISTIC_ACTION_BALL_CLOSE_CLICK = 'ball_close_click' // 点击关闭
global.STATISTIC_ACTION_BALL_MASK_CLICK = 'ball_mask_click' // 点击阴影部分关闭
global.STATISTIC_ACTION_BALL_PLATFORM_CLICK = 'ball_platform_click' // 点击平台
global.STATISTIC_ACTION_BALL_GOBACK_CLICK = 'ball_goback_click' // 返回上一页
global.STATISTIC_ACTION_BALL_SERVICE_CLICK = 'ball_service_click' // 点击客服

global.STATISTIC_ACTION_BALL_APP_OPEN_CLICK = 'app_ball_open' // 打开悬浮球
global.STATISTIC_ACTION_BALL_APP_COUPON_CLICK = 'app_ball_coupon_click' // 点击礼包
global.STATISTIC_ACTION_BALL_APP_MSG_CLICK = 'app_ball_msg_click' // 点击消息
global.STATISTIC_ACTION_BALL_APP_ACT_CLICK = 'app_ball_act_click' // 点击活动
global.STATISTIC_ACTION_BALL_APP_ACT_ITEM_CLICK = 'app_ball_act_item_click' // 点击活动条目
global.STATISTIC_ACTION_BALL_APP_CLOSE_CLICK = 'app_ball_close_click' // 点击关闭
global.STATISTIC_ACTION_BALL_APP_MASK_CLICK = 'app_ball_mask_click' // 点击阴影部分关闭
global.STATISTIC_ACTION_BALL_APP_PLATFORM_CLICK = 'app_ball_platform_click' // 点击平台

global.STATISTIC_ACTION_QUIT_GOBACK_CLICK = 'quit_goback_click' // 退弹点击返回
global.STATISTIC_ACTION_QUIT_ADD_DESK_CLICK = 'quit_add_desk_click' // 退弹添加至桌面
global.STATISTIC_ACTION_QUIT_CLICK_AD_CLICK = 'quit_click_ad_click' // 退弹点击广告
global.STATISTIC_ACTION_QUIT_SELECT_SEL_CLICK = 'quit_select_sel_click' // 退弹设定不再显示
global.STATISTIC_ACTION_QUIT_CANCEL_SEL_CLICK = 'quit_cancel_sel_click' // 退弹设定显示
global.STATISTIC_ACTION_QUIT_SHORT_CUT_CLICK = 'quit_short_cut_click' // 退弹创建桌面快捷

global.STATISTIC_ACTION_GAMECENTER_INDEX_ADD_DESK = 'game_center_index_add_desk' // 从首页将游戏中心添加到桌面
global.STATISTIC_ACTION_GAMECENTER_MINE_ADD_DESK = 'game_center_mine_add_desk' // 从我的页面将游戏中心添加到桌面
global.STATISTIC_ACTION_GAMECENTER_ADD_DESK = 'game_center_add_desk' // 将游戏中心添加到桌面
// 搜索页
global.STATISTIC_ACTION_SEARCH_CARD = 'searchCard' // 搜索card转化
global.STATISTIC_ACTION_SEARCH = 'search_click' // 搜索点击
global.STATISTIC_ACTION_BALL_APP_SERVICE_CLICK = 'app_ball_service_click' // 点击客服

global.STATISTIC_ACTION_CP_USER_CREATE_SHORTCUT_CLICK = 'cp_user_create_shortcut' // CP创建快捷方式
global.STATISTIC_ACTION_CP_USER_SHARE_CLICK = 'cp_user_share_click' // cp分享

// 积分相关
global.STATISTIC_ACTION_CHECKIN_TAB = 'ball_checkin_tab'
global.STATISTIC_ACTION_CHECKIN_AD = 'checkin_ad'
global.STATISTIC_ACTION_CHECKIN_CONTINUEBUTTON_AWARD = 'checkin_award'
global.STATISTIC_MINE_CHECKIN_GIFT = 'mine_checkin_gift' // 我的-签到
global.STATISTIC_CHECKIN_SCORE_LOG = 'checkin_score_log' // 积分日志
global.STATISTIC_CHECKIN_AD_ICON = 'checkin_ad_icon' // 签到页广告点击
global.STATISTIC_CHECKIN_ACT = 'checkin_act' // 签到页更多跳转活动页

global.STATISTIC_ACTION_CLICK_INDEX_ICON = 'index_icon_pop'  // 首页悬浮广告点击
global.STATISTIC_ACTION_SHOW_INDEX_ICON = 'index_icon_pop_show'  // 首页悬浮广告展示
global.STATISTIC_ACTION_CLICK_CLOSE_INDEX_ICON = 'index_close_icon'  // 首页关闭悬浮广告
global.STATISTIC_ACTION_CLICK_CLOSE_HOME_AD_POP = 'home_ad_pop_close'  // 首页关闭弹框广告
global.STATISTIC_ACTION_CLICK_JUMP_HOME_AD_POP = 'home_ad_pop_jump'  // 首页弹框广告点击
global.STATISTIC_MSG_ACT_CLICK = 'msg_act_click'  // 消息详情点击活动跳转
global.STATISTIC_MSG_DETAIL_CLICK = 'msg_detail_click'  // 消息详情点击

global.STATISTIC_DETAIL_PAGE_DETAIL_CLICK = 'detail_page_detail_click'  // 详情页详情点击
global.STATISTIC_DETAIL_PAGE_WELFARE_CLICK = 'detail_page_welfare_click'  // 详情页福利点击
global.STATISTIC_DETAIL_PAGE_VIDEO_CLICK = 'detail_page_video_click'  // 详情页视频点击

global.STATISTIC_INDEX_PAGE_WELFARE_MORE_CLICK = 'index_page_welfare_more_click'  // 首页福利专区更多
// 积分商城
global.STATISTIC_MINE_MALL_CLICK = 'mine_mall_click'  // 我的-商城
global.STATISTIC_INDEX_MALL_LEFT_CLICK = 'index_mall_left_click'  // 首页-商城左侧
global.STATISTIC_INDEX_MALL_RIGHT_CLICK = 'index_mall_right_click'  // 首页-商城右侧
global.STATISTIC_INDEX_MALL_LEFT_AND_RIGHT_CLICK = 'index_mall_left_and_right_click'  // 首页-商城左右侧总点击
global.STATISTIC_INDEX_MALL_MORE_CLICK = 'index_mall_more_click'  // 首页-商城更多

global.TENCENT_CAPTCHA_GIFT_APPID = '2023961974'  // 礼包策略防刷
global.STATISTIC_GRADE_PAGE_ACT = 'grades_page_act' // 等级页面活动埋点
global.STATISTIC_MINE_CLICK = 'mine_click_'  // 我的页面埋点

global.STATISTIC_NEW_GAME_IMG_CLICK = 'new_game_act_img_click' // 新游来了埋点
global.STATISTIC_MY_GAME_MORE_RECENT = 'my_game_more_recent' // 我玩过的游戏更多
global.STATISTIC_MY_GAME_INTEREST = 'my_game_interest_game' // 我玩过的游戏推荐感兴趣的
global.STATISTIC_MY_GAME_TO_INDEX = 'my_game_to_index' // 我玩过的游戏底部跳转首页
global.STATISTIC_MY_RECENT_GAMES = 'my_recent_games' // 我最近玩过的游戏
global.STATISTIC_GIFT_CENTER_BOTTOM_MORE = 'gift_center_bottom_more' // 福利专区底部查看更多

global.STATISTIC_CHECKIN_AD_CLICK = 'checkin_ad_click' // 签到页广告跳转
global.STATISTIC_FAB_TASK_MORE = 'fab_task_more' // 任务更多

// 新消息相关
global.STATISTIC_NEW_MSG_SHOW = 'h5_new_push_msg_show'  // 新消息push展示量
global.STATISTIC_NEW_MSG_CLICK = 'h5_new_push_msg_click' // 新消息push点击量

global.STATISTIC_MY_GAME_INTEREST_GAME_CLICK = 'my_game_interest_game_click' // 我玩过的游戏图片点击
global.STATISTIC_PAY_GRADE_SHOW = 'pay_grade_show' // 支付页等级按钮点击
global.STATISTIC_PAY_GRADE_CLICK = 'pay_grade_click' // 支付页等级按钮点击

global.STATISTIC_REALNAME_POP_SHOW = 'realname_pop_show' // 实名制弹窗
global.STATISTIC_REALNAME_POP_BUTTON_CLICK = 'realname_pop_button_click' // 实名制弹窗点击
global.STATISTIC_REALNAME_POP_CLICK_RETURN = 'realname_pop_click_return'// 实名制点击返回



// WEBPACK FOOTER //
// ./src/v2/config/global.js